import { useNavigate } from 'react-router-dom';
import * as S from './ResetPasswordComplete.styled';

function ResetPasswordComplete() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <S.Page>
      <S.Header>아이디/비밀번호 찾기</S.Header>

      <S.ContentWrap>
        <S.CheckIcon />
        <S.Message>비밀번호 변경이 완료되었습니다!</S.Message>
      </S.ContentWrap>

      <S.BottomButton onClick={handleLogin}>
        로그인
      </S.BottomButton>
    </S.Page>
  );
}

export default ResetPasswordComplete;
